import React, { Fragment, useEffect, useState } from "react";
import "./Header.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Iconregister from "../../assets/Iconregister.svg";
import { PdfEnglish, PdfJapanese } from "../../constants/pdfConstants";

const Header = (props) => {
  const { t, i18n } = useTranslation("common");
  const [toggle, setToggle] = useState(false);
  const [align, setAlign] = useState(false);
  const handleChange = (e) => {
    if (e.target.value === "english") {
      i18n.changeLanguage("en");
    } else if (e.target.value === "japanese") {
      i18n.changeLanguage("jap");
    }
  };

  window.addEventListener(
    "resize",
    () => {
      if (window.innerWidth < 800) {
        setAlign(true);
      } else {
        setAlign(false);
      }
    },
    false
  );

  useEffect(() => {
    if (window.innerWidth < 800) {
      setAlign(true);
    } else {
      setAlign(false);
    }
  }, []);

  return (
    <>
      <nav
        className={
          "nav nav-header nav-large nav-sticky border " +
          (align ? "nav-vertical" : "nav-horizontal")
        }
        data-toggle="nav"
        data-responsive="true"
      >
        <div className="nav-overlay"></div>
        <div className="nav-brand">
          <span className="dls-logo-bluebox-solid-md flex">
            <Link to="/" rel="noopener noreferrer">
              <img
                src="https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/logos/dls-logo-bluebox-solid.svg"
                alt="American Express"
              />
            </Link>
          </span>
          <ul className="nav-menu">
            <li className="nav-title">
              <Link to="/" className="nav-change">
                American Express @ Work
                <img
                  src={Iconregister}
                  alt="register icon"
                  style={{ padding: "5px" }}
                />
              </Link>
            </li>
          </ul>
        </div>
        <button
          className="nav-burger hidden-md-up dls-bright-blue"
          title="Close menu"
          aria-haspopup="true"
          aria-expanded={toggle}
          onClick={() => setToggle(!toggle)}
        ></button>

        <ul className="nav-menu right-nav-menu">
          <li className="nav-item">
            <Link
              to="/"
              className="nav-link nav-links-header"
              rel="noopener noreferrer"
            >
              {t("header.home")}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/privacy-links"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-links-header"
            >
              {t("header.privacylinks")}
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/products-and-roles"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-links-header"
            >
              {t("header.prodcutsandroles")}
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-links-header"
            >
              {t("header.contactus")}
            </Link>
          </li>

          <li className="nav-item ">
            {localStorage.getItem("lang") === "en" ? (
              <a
              href={PdfEnglish}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
              >
                {t("header.onboardingGuide")}
              </a>
            ) : (
              <a
              href={PdfJapanese}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
              >
                {t("header.needHelp")}
              </a>
            )}
          </li>

          {props.showlang ? (
            <ul
              className="list-links-inline-separator"
              styleType="primary"
              aria-label="Primary"
            >
              <li>
                <button value="english" onClick={handleChange}>
                  English
                </button>
              </li>
              <li>
                <button value="japanese" onClick={handleChange}>
                  日本語
                </button>
              </li>
            </ul>
          ) : null}
        </ul>
      </nav>
    </>
  );
};
export default Header;
